/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import QueryString from 'qs';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    array, shape, string, arrayOf, number, bool,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import GraphqlApplePay from '../../../GraphqlCommonComponents/GraphqlApplePay';
import { getTotalItemInCart } from '../../../../../../state/ducks/Common/Common-Selectors';
import { getPassportSubscriptionStatus } from '../../../../../../state/ducks/Passport/Passport-Selectors';
import GooglePayButton from '../../../../../pages/Checkout/containers/Common/PaymentButton/GooglePayButton/GooglePayButton';
import { getCountryDeliverableTwoDigit } from '../../../../../../state/ducks/Checkout/ducks/Checkout/Checkout-Helper';
import { googlePaySupportedBrand } from '../../../../../../state/ducks/Payment/plugins/GooglePay/GooglePay-Helper';
// import { getFeatureFlags, getPresentationFamily } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getLocationType } from '../../../../../../state/ducks/App/App-Selectors';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';
import KlarnaProductPageNoPriceBadge from '../../../../Checkout/KlarnaPaymentOnSiteMessage/KlarnaProductPageNoPriceBadge/KlarnaProductPageNoPriceBadge';

const useStyles = makeStyles((theme) => ({
    oneClickContainer: {
        width: '100%',
    },
    descriptionInfo: {
        color: '#000',
        fontSize: '0.8em',
        lineHeight: '1.1em',
        margin: '10px 0 15px',
        width: '100%',
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            padding: '0',
        },
    },
}));

const OneClickPaymentBuilder = ({
    selectedSku, noOfItemsInCart,
    movieSelected, passportInCart, hasWine,
    isStandAloneMovieSku, locationType,
    productCategories,
}) => {
    const { featureFlags: flags = {}, presentation_family: presentationFamily = '' } = useContext(CrossMerch);
    const classes = useStyles();
    const location = useLocation();
    const searchTerms = QueryString.parse(location.search.replace(/^\?/, ''));
    const hasSubscriptionParam = searchTerms?.subscription?.toLowerCase && searchTerms.subscription.toLowerCase() === 'basic';
    const allowOneClickPayment = (selectedSku.ageVerifyFlag === 'false' && !hasWine && !passportInCart && !movieSelected && !isStandAloneMovieSku);
    // temporarily disabling apple pay on business addresses on pdp because of 4th of July flex.
    const isBusinessAddressAndIsPDP = !!(locationType === 'Business' && !location.pathname.includes('checkout'));

    const displayApplePay = typeof window !== 'undefined'
        && window.ApplePaySession
        && flags['is-apple-pay-enabled-pdp'] === true
        && allowOneClickPayment
        && noOfItemsInCart === 0
        && !hasSubscriptionParam
        && !isBusinessAddressAndIsPDP
        && !(productCategories || []).includes('digital_delivery');

    const displayGooglePay = flags['is-pdp-google-pay-enabled']
        && allowOneClickPayment
        && (
            presentationFamily === 'flower'
            && googlePaySupportedBrand(selectedSku.brandId)
        )
        && !(productCategories || []).includes('digital_delivery');

    const displayKlarnaNoPriceBadge = flags['is-klarna-payment-pdp-no-price-badge-enabled'];

    return (
        <Grid container direction="column" className={classes.oneClickContainer}>
            {displayApplePay && (
                <Grid item container direction="column">
                    <Grid item>
                        <GraphqlApplePay
                            selectedSku={selectedSku}
                        />
                    </Grid>
                </Grid>
            )}
            {displayGooglePay && (
                <Grid item container direction="column">
                    <Grid item>
                        <GooglePayButton
                            selectedSkuId={selectedSku.id}
                            selectedSkuBrand={selectedSku.brandId}
                            buttonPosition="primary"
                            isCheckout={false}
                            countriesDeliverable={getCountryDeliverableTwoDigit(selectedSku.brandId, selectedSku.countries, selectedSku.isInternational)}
                        />
                    </Grid>
                </Grid>
            )}
            {displayKlarnaNoPriceBadge && (
                <KlarnaProductPageNoPriceBadge
                    selectedSku={selectedSku}
                />
            )}
        </Grid>
    );
};

const mapStateToProps = (state) => ({
    // flags: getFeatureFlags(state),
    noOfItemsInCart: getTotalItemInCart(state),
    passportInCart: getPassportSubscriptionStatus(state),
    // presentationFamily: getPresentationFamily(state),
    locationType: getLocationType(state),
});

OneClickPaymentBuilder.propTypes = {
    hasWine: bool,
    selectedSku: shape({
        __typename: string.isRequired,
        id: string.isRequired,
        brandId: string.isRequired,
        name: string.isRequired,
        ageVerifyFlag: string.isRequired,
        minAge: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
    }).isRequired,
    noOfItemsInCart: number,
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }),
    passportInCart: bool.isRequired,
    isStandAloneMovieSku: bool,
    locationType: string,
    productCategories: array.isRequired,
};

OneClickPaymentBuilder.defaultProps = {
    movieSelected: null,
    hasWine: false,
    isStandAloneMovieSku: false,
    noOfItemsInCart: 0,
    locationType: 'Residence',
};

export default connect(mapStateToProps, null)(OneClickPaymentBuilder);
